import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Facebook, Instagram, Twitter, Mail, Phone, MapPin } from "lucide-react";
import { Logo } from "./Logo";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#273B59] text-white">
      <div className="ol-container py-16">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          <div className="col-span-2 md:col-span-3 lg:col-span-2">
            <Logo inverted />
            <p className="mt-4 text-sm text-white/70 max-w-xs">
              India's trusted digital loan distribution platform. Compare and apply for Personal, Business, and Flexi Overdraft loans from leading Banks & NBFCs.
            </p>
            <div className="mt-5 flex gap-3">
              <a href="#" aria-label="LinkedIn" className="p-2 rounded-md bg-white/10 hover:bg-[#1088D4] transition-colors"><Linkedin size={16}/></a>
              <a href="#" aria-label="Facebook" className="p-2 rounded-md bg-white/10 hover:bg-[#1088D4] transition-colors"><Facebook size={16}/></a>
              <a href="#" aria-label="Instagram" className="p-2 rounded-md bg-white/10 hover:bg-[#1088D4] transition-colors"><Instagram size={16}/></a>
              <a href="#" aria-label="X" className="p-2 rounded-md bg-white/10 hover:bg-[#1088D4] transition-colors"><Twitter size={16}/></a>
            </div>
          </div>

          <FooterCol title="Company" links={[
            ["About Us","/about"],["Contact Us","/contact"],["Careers","/about#careers"]
          ]}/>
          <FooterCol title="Loans" links={[
            ["Personal Loan","/personal-loan"],["Business Loan","/business-loan"],["Flexi Overdraft Loan","/overdraft-loan"]
          ]}/>
          <FooterCol title="Tools" links={[
            ["EMI Calculator","/tools/emi-calculator"],["Eligibility Calculator","/tools/eligibility-calculator"],["Compare Loans","/tools/compare-loans"],["Balance Transfer","/tools/balance-transfer-calculator"]
          ]}/>
          <FooterCol title="Legal" links={[
            ["Privacy Policy","/privacy"],["Terms & Conditions","/terms"],["Disclaimer","/disclaimer"]
          ]}/>
        </div>

        <div className="mt-10 pt-8 border-t border-white/15 grid md:grid-cols-3 gap-6 text-sm">
          <div className="flex items-center gap-2 text-white/80"><Phone size={14} className="text-[#1088D4]"/> +91 93702 51358</div>
          <div className="flex items-center gap-2 text-white/80"><Mail size={14} className="text-[#1088D4]"/> support@oneloan.in</div>
          <div className="flex items-center gap-2 text-white/80"><MapPin size={14} className="text-[#1088D4]"/> Vasai, India</div>
        </div>

        <div className="mt-8 p-4 bg-white/5 rounded-lg text-xs text-white/60 leading-relaxed">
          <strong className="text-white/80">Disclaimer:</strong> OneLoan.in is a loan facilitation and distribution platform. Loan approval, interest rates, loan amount, tenure, and terms are determined solely by the respective Banks, NBFCs, and lending partners. Submission of an application does not guarantee approval. OneLoan does not directly provide loans unless specifically stated. Users should carefully review all terms and conditions before applying. All interest rates and figures shown on this website are indicative and subject to change at the lender's discretion.
        </div>

        <div className="mt-6 text-center text-xs text-white/50">
          © {new Date().getFullYear()} OneLoan.in — All rights reserved.
        </div>
      </div>
    </footer>
  );
};

const FooterCol = ({ title, links }) => (
  <div>
    <h4 className="text-sm font-semibold tracking-wider uppercase text-white mb-4">{title}</h4>
    <ul className="space-y-2">
      {links.map(([label, to]) => (
        <li key={to}><Link to={to} className="text-sm text-white/70 hover:text-[#1088D4] transition-colors">{label}</Link></li>
      ))}
    </ul>
  </div>
);
